import * as Routes from 'constants/Routes'

export default () => ({
  path: Routes.POLICY,
  getComponent: async function (nextState, cb) {
    const module = await import('./PolicyContainer')
    cb(null, module.default)
  }
})
